export class BocciaturaConsegnaFase1 {
    
    retOK!:boolean;
    duvriOK!:boolean;
    verbaleOK!:boolean;

    noteRET!:string;
    noteDUVRI!:string;
    noteVerbale!:string;

    problemiRET!:string[];
    problemiDUVRI!:string[];
    problemiVerbale!:string[];
    
  }
  